
import { ajaxPost, ajaxPut } from "../data/ajax";
import { GraphUserModel } from './GraphUserModel';
import { TemplateParameter } from "./Template";

export default class CreateWorkspace  {
    id: string | undefined;
    name: string;
    previousRequest: string;
    description: string;
    template: string;
    owner!: GraphUserModel;
    ownerEmail!: string;
    budget!: string;
    endDate!: Date;
    costcenter: string;
    parameters: any;// ComponentParameter_Post[];
    
    constructor(workspaceObject?: CreateWorkspace) { 
        if(workspaceObject){
            this.id = workspaceObject.id;
            this.name = workspaceObject.name;
            this.description = workspaceObject.description;
            this.template = workspaceObject.template;
            this.ownerEmail = workspaceObject.ownerEmail;
            this.budget = workspaceObject.budget;
            this.endDate = workspaceObject.endDate;
            this.costcenter = workspaceObject.costcenter;
            this.parameters = workspaceObject.parameters;
            this.owner = workspaceObject.owner;
        } else {
            this.name = "";
            this.description = "";
            this.template = "";
            this.costcenter = "";
            this.previousRequest = "";
        }
    }

    async create(token: string) {
        const url = process.env.VUE_APP_ROOT_API + "workspace/requestworkspace"
        var result = await ajaxPost(url, token, this.getApiObject());
        return result;
    }

    async update(workspaceId: string, token: string) {
        const url = process.env.VUE_APP_ROOT_API + "workspace/requestWorkspaceBudgetChange/" + workspaceId;
        var result = await ajaxPut(url, token, this.getApiObjectForUpdate());
        return result;
    }

    getApiObject(): any{
        var returnObject = {
            name: this.name,
            description: this.description,
            templateName: this.template,
            // owneremail: this.owner.mail,
            budget: parseFloat(this.budget),
            renewalPeriod: "Annually",
            endDate: this.endDate.toISOString(),
            costcenter: this.costcenter,
            parameters: Object.values(this.parameters)
        }
        return returnObject;
    }

    getApiObjectForUpdate(): any {
        var returnObject = {
            name: this.name,
            description: this.previousRequest + " Description of the new request: " + this.description, //When changing this value, update the maxlenght validation in workspaceUpdate
            templateName: "",
            owneremail: this.ownerEmail,
            budget: parseFloat(this.budget),
            renewalPeriod: "Annually",
            endDate: this.endDate.toISOString(),
            costcenter: this.costcenter
        }
        return returnObject;
    }
}

export class ComponentParameter_Post {
    name: string;
    type: string;
    value: string;

    constructor(templateParameter: TemplateParameter){
        this.name = templateParameter.name;
        this.type = templateParameter.type;
        this.value = null;
    }

}
